import { APIRepository } from "~/context/Shared/infrastructure/APIRepository";
import { MovementRepository } from "../domain/MovementRepository";
import { vectiAppApiUrl } from "~/context/Shared/infrastructure/Config";
import { Criteria } from "~/context/Shared/domain/criteria/Criteria";
import { Page } from "~/context/Shared/domain/page/Page";
import { Movement } from "../domain/Movement";
import { MovementAccount } from "~/context/Shared/domain/MovementAccount";
import { SearchData } from "~/context/Shared/domain/criteria/SearchData";
import { PageFull } from "~/context/Shared/domain/page/PageFull";
import { DocumentDomain } from "~/context/Shared/domain/DocumentDomain";

export function createApiMovementRepository(): MovementRepository {
  return new APIMovementRepository();
}

export class APIMovementRepository extends APIRepository implements MovementRepository {
  constructor() {
    super(vectiAppApiUrl());
  }
  getMovements(): Promise<Movement[]> {
    throw new Error("Method not implemented.");
  }

  updateMovement(_movement: Movement): Promise<void> {
    throw new Error("Method not implemented.");
  }

  getMovementsByAccountUid(accountUid: string): Promise<Movement[]> {
    return this.doGet<Movement[]>("/api/movements/account/" + accountUid.toString());
  }

  getMovementsByCompanyUid(companyUid: string): Promise<Movement[]> {
    return this.doGet<Movement[]>("/api/movements/company/" + companyUid.toString());
  }

  getMovementsFullByCompanyUid(companyUid: string): Promise<Movement[]> {
    return this.doGet<Movement[]>("/api/movements/full/company/" + companyUid?.toString());
  }

  getMovementsFullByCompanyYearMonth(companyUid: string, year:number, month:number): Promise<Movement[]> {
    return this.doGet<Movement[]>("/api/movements/full/company/" + companyUid?.toString() + "/year/" + year + "/month/" + month);
  }

  getMovementsFullByCompanyYear(companyUid: string, year:number): Promise<Movement[]> {
    return this.doGet<Movement[]>("/api/movements/full/company/" + companyUid?.toString() + "/year/" + year);
  }

  getMovementsFullBalanceZeroByCompanyYear(companyUid: string, year:number): Promise<Movement[]> {
    return this.doGet<Movement[]>("/api/movements/full/company/" + companyUid?.toString() + "/year/" + year + "/balancezero");
  }

  getMovementsFullBalanceNotZeroByCompanyYear(companyUid: string, year:number): Promise<Movement[]> {
    return this.doGet<Movement[]>("/api/movements/full/company/" + companyUid?.toString() + "/year/" + year + "/balancenotzero");
  }


  getMovementFullByCompanyAndId(companyUid: string, movementUid: string): Promise<Movement | undefined>{
    return this.doGet<Movement>("/api/movements/full/company/" + companyUid?.toString() + "/movement/" + movementUid?.toString());
  }

  getMovementsFullRepositoryByCriteria(criteria: Criteria): Promise<Movement[]> {
    return this.doPost<Criteria, Movement[]>("/api/movements/full/company/criteria", null, criteria);
  }

  getMovementsFullRepositoryBySearch(search: SearchData): Promise<Movement[]> {
    return this.doPost<SearchData, Movement[]>("/api/movements/full/company/searchmov", null, search);
  }

  getMovementsFullWithReconciliationsByCompanyUid(companyUid: string): Promise<Movement[]> {
    return this.doGet<Movement[]>("/api/movements/full/reconciliations/company/" + companyUid.toString());
  }


  getMovementsWithReconciliationsByCompanyUid(companyUid: string): Promise<Movement[]> {
    return this.doGet<Movement[]>("/api/movements/reconciliations/company/" + companyUid.toString());
  }


  getMovementsWithCompanyByCompanyUid(companyUid: string): Promise<MovementAccount[]> {
    return this.doGet<MovementAccount[]>("/api/compose/movements/company/" + companyUid.toString());
  }

  async findBestMatchForDocument(companyId: string, documentId: string, type:string, tolerance: number): Promise<PageFull<Movement>> {
    console.log("(API Movement): findBestMatchForDocument:" + companyId + ", document:" + documentId + ", type:" +  type + " tolerance:" + tolerance);
    const response = await this.doGet<PageFull<Movement>>("/api/movements/bestmatch/company/" + companyId?.toString() + "/document/" + documentId?.toString() + "/type/" + type?.toString() + "/tolerance/" + tolerance?.toString());
    console.log("(API Movement): " + JSON.stringify(response));
    return response;
  }



  async getMovementsByCompanyUidDistance(companyId: string, documentId: string, type: string): Promise<Movement[]> {
    const a = await this.doGet<Movement[]>("/api/movements/company/" + companyId.toString() + "/document/" + documentId.toString() + "/type/" + type.toString());
    //console.log("getMovementsByCompanyUidDistance: " + JSON.stringify(a));
    return a;
  }

  async getMovementsFullByCompanyUidDistance(companyId: string, documentId: string, type: string): Promise<Movement[]> {
    const a = await this.doGet<Movement[]>("/api/movements/full/company/" + companyId.toString() + "/document/" + documentId.toString() + "/type/" + type.toString());
    //console.log("getMovementsByCompanyUidDistance: " + JSON.stringify(a));
    return a;
  }

  async getMovementsFullByCompanyClientUidDistance(companyId: string, documentId: string, type: string, clientId:string): Promise<Movement[]> {
    const a = await this.doGet<Movement[]>("/api/movements/full/company/" + companyId.toString() + "/document/" + documentId.toString() + "/type/" + type.toString() + "/client/" + clientId.toString());
    //console.log("getMovementsByCompanyUidDistance: " + JSON.stringify(a));
    return a;
  }

  async getMovementsFullByCompanyProviderUidDistance(companyId: string, documentId: string, type: string, providerId:string): Promise<Movement[]> {
    const a = await this.doGet<Movement[]>("/api/movements/full/company/" + companyId.toString() + "/document/" + documentId.toString() + "/type/" + type.toString() + "/provider/" + providerId.toString());
    //console.log("getMovementsByCompanyUidDistance: " + JSON.stringify(a));
    return a;
  }

  async getMovementsFullByCompanyCollaboratorUidDistance(companyId: string, documentId: string, type: string, collaboratorId:string): Promise<Movement[]> {
    const a = await this.doGet<Movement[]>("/api/movements/full/company/" + companyId.toString() + "/document/" + documentId.toString() + "/type/" + type.toString() + "/collaborator/" + collaboratorId.toString());
    //console.log("getMovementsByCompanyUidDistance: " + JSON.stringify(a));
    return a;
  }





  async findNearMovementsForMovement(companyId: string, movementId: string, criteria: Criteria): Promise<Page<Movement>> {
    console.log("(API Movement): llamando findNearMovementsForMovement");
    const response = await this.getMovementsFullByCompanyDistanceAndCriteria(companyId, movementId, DocumentDomain.MOVEMENT, criteria);
    return response;
  }

  async findNearMovementsForDocument(companyId: string, documentId: string, type: string, criteria: Criteria): Promise<Page<Movement>> {
    console.log("(API Movement): llamando findNearMovementsForDocument");
    const response = await this.getMovementsFullByCompanyDistanceAndCriteria(companyId, documentId, type, criteria);
    return response;
  }

  async findClientMovementsForDocument(companyId: string, documentId: string, type: string, clientId:string, criteria: Criteria): Promise<Page<Movement>> {
    console.log("(API Movement): llamando findClientMovementsForDocument");
    const response = await this.getMovementsFullByCompanyClientDistanceAndCriteria(companyId, documentId, type, clientId, criteria);
    return response;
  }

  async findProviderMovementsForDocument(companyId: string, documentId: string, type: string, providerId:string, criteria: Criteria): Promise<Page<Movement>> {
    console.log("(API Movement): llamando findProviderMovementsForDocument");
    const response = await this.getMovementsFullByCompanyProviderDistanceAndCriteria(companyId, documentId, type, providerId, criteria);
    return response;
  }

  async findCollaboratorMovementsForDocument(companyId: string, documentId: string, type: string, collaboratorId:string, criteria: Criteria): Promise<Page<Movement>>{
    console.log("(API Movement): llamando findClientMovementsForDocument");
    const response = await this.getMovementsFullByCompanyCollaboratorDistanceAndCriteria(companyId, documentId, type, collaboratorId, criteria);
    return response;
  }



  getMovementsByMovementUid(movementId: string): Promise<Movement | undefined> {
    return this.doGet<Movement>("/api/movements/" + movementId);
  }
  getMovementsByAccountUidPaginate(_movementUid: string, _page: number): Promise<Movement[]> {
    throw new Error("Method not implemented.");
  }
  getMovementsByCriteria(_criteria: Criteria): Promise<Page<Movement>> {

    throw new Error("Method not implemented.");
  }

  //TODO: revisar el cross que se produce por enviarle un ibjeto criteria. NO estoy usando companyId
  getMovementsByCompanyAccountAndCriteria(_companyUid: string, accountId: string, criteria: Criteria): Promise<Page<Movement>> {
    console.log("calling getMovementsByAccountAndCriteria API Movement");
    return this.getMovementsByAccountAndCriteria(accountId, criteria);

  }

  async getMovementsByCompanyAndCriteria(companyUid: string, criteria: Criteria): Promise<Page<Movement>> {
    try {
      const movements = await this.getMovementsByCompanyUid(companyUid);
      const pageSize = criteria.pageSize;
      const start = (criteria.pageNumber - 1) * pageSize;
      const end = criteria.pageNumber * pageSize;
      const paginatedMovements = this.filterByCriteria(criteria, movements);
      return Promise.resolve(
        new Page<Movement>(
          paginatedMovements.length,
          paginatedMovements.slice(start, end)
        )
      );
    } catch {
      return Promise.resolve(
        new Page<Movement>(
          0,
          []
        )
      );
    }
  }

  async getMovementsFullPreviredByCompanyAndCriteria(companyUid: string, criteria: Criteria): Promise<Page<Movement>> {
    try{
    const search = 'prevision'
    const searchData = new SearchData(companyUid, search); 
    const movements = await this.getMovementsFullRepositoryBySearch(searchData);
    console.log("getMovementsFullPreviredByCompanyAndCriteria:" + JSON.stringify(movements));
      const pageSize = criteria.pageSize;
      const start = (criteria.pageNumber - 1) * pageSize;
      const end = criteria.pageNumber * pageSize;
      const paginatedMovements = this.filterByCriteria(criteria, movements);
      return Promise.resolve(
        new Page<Movement>(
          paginatedMovements.length,
          paginatedMovements.slice(start, end)
        )
      );
    } catch {
      return Promise.resolve(
        new Page<Movement>(
          0,
          []
        )
      );

    }

  }

  async getMixedMovementsFullByCompanyYearAndCriteria(companyUid: string, year: number, criteria: Criteria): Promise<Page<Movement>> {
  try {

    console.log("(ApiMovementRepository) getMixedMovementsFullByCompanyYearAndCriteria");
    const [movementsWithBalance, movementsZeroBalance] = await Promise.all([
      this.getMovementsFullBalanceNotZeroByCompanyYear(companyUid, year), 
      this.getMovementsFullBalanceZeroByCompanyYear(companyUid, year)  
    ]);

    const positiveFiltered = this.filterByCriteria(criteria, movementsWithBalance);
    const zeroFiltered = this.filterByCriteria(criteria, movementsZeroBalance);

    const mixedMovements: Movement[] = [];
    const maxLength = Math.max(positiveFiltered.length, zeroFiltered.length);

    for (let i = 0; i < maxLength; i++) {
      // Si quedan elementos positivos, agregamos uno
      if (i < positiveFiltered.length) {
        mixedMovements.push(positiveFiltered[i]);
      }
      // Si quedan elementos cero, agregamos uno
      if (i < zeroFiltered.length) {
        mixedMovements.push(zeroFiltered[i]);
      }
    }

      const pageSize = criteria.pageSize;
      const start = (criteria.pageNumber - 1) * pageSize;
      const end = criteria.pageNumber * pageSize;

    const paginatedMixedMovements = mixedMovements.slice(start, end);

    return Promise.resolve(
      new Page<Movement>(
        mixedMovements.length, 
        paginatedMixedMovements
      )
    );

  } catch (error) {
    console.error("Error fetching mixed movements", error); // Buena práctica loguear el error
    return Promise.resolve(
      new Page<Movement>(
        0,
        []
      )
    );
  }

  }



  async getMovementsFullByCompanyAndCriteria(companyUid: string, criteria: Criteria): Promise<Page<Movement>> {
    try {
      const movements = await this.getMovementsFullByCompanyUid(companyUid);
      //const movements = await this.getMovementsFullRepositoryByCriteria(criteria);
      const pageSize = criteria.pageSize;
      const start = (criteria.pageNumber - 1) * pageSize;
      const end = criteria.pageNumber * pageSize;
      const paginatedMovements = this.filterByCriteria(criteria, movements);
      console.log("paginatedMovements: " + paginatedMovements.length);
      console.log("pageSize: " + pageSize);
      console.log("start: " + start);
      console.log("end: " + end);
      return Promise.resolve(
        new Page<Movement>(
          paginatedMovements.length,
          paginatedMovements.slice(start, end)
        )
      );
    } catch {
      return Promise.resolve(
        new Page<Movement>(
          0,
          []
        )
      );

    }

  }

  async getMovementsFullByCompanyYearMonthAndCriteria(companyUid: string, year:number, month:number, criteria: Criteria): Promise<Page<Movement>> {
    try {
      const movements = await this.getMovementsFullByCompanyYearMonth(companyUid, year, month);
      //const movements = await this.getMovementsFullRepositoryByCriteria(criteria);
      const pageSize = criteria.pageSize;
      const start = (criteria.pageNumber - 1) * pageSize;
      const end = criteria.pageNumber * pageSize;
      const paginatedMovements = this.filterByCriteria(criteria, movements);
      console.log("paginatedMovements: " + paginatedMovements.length);
      console.log("pageSize: " + pageSize);
      console.log("start: " + start);
      console.log("end: " + end);
      console.log("year: " + year);
      console.log("month: " + month);
      return Promise.resolve(
        new Page<Movement>(
          paginatedMovements.length,
          paginatedMovements.slice(start, end)
        )
      );
    } catch {
      return Promise.resolve(
        new Page<Movement>(
          0,
          []
        )
      );

    }

  }


  async getMovementsFullRepositoryByCompanyAndSearch(companyUid: string, search: string): Promise<Page<Movement>> {
    const searchData = new SearchData(companyUid, search);
    console.log("getMovementsFullRepositoryByCompanyAndSearch: companyId" + companyUid + "->" + JSON.stringify(searchData));
    const movements = await this.getMovementsFullRepositoryBySearch(searchData);
    return Promise.resolve(
      new Page<Movement>(
        movements.length,
        movements
      )
    );
  }



  async getMovementsFullRepositoryByCompanyAndCriteria(companyUid: string, criteria: Criteria): Promise<Page<Movement>> {
    console.log("getMovementsFullRepositoryByCompanyAndCriteria: companyId" + companyUid + "->" + JSON.stringify(criteria));
    const movements = await this.getMovementsFullRepositoryByCriteria(criteria);
    const pageSize = criteria.pageSize;
    const start = (criteria.pageNumber - 1) * pageSize;
    const end = criteria.pageNumber * pageSize;
    return Promise.resolve(
      new Page<Movement>(
        movements.length,
        movements.slice(start, end)
      )
    );
  }


  async getMovementsWithReconciliationsByCompanyAndCriteria(companyUid: string, criteria: Criteria): Promise<Page<Movement>> {
    const movements = await this.getMovementsWithReconciliationsByCompanyUid(companyUid);
    const pageSize = criteria.pageSize;
    const start = (criteria.pageNumber - 1) * pageSize;
    const end = criteria.pageNumber * pageSize;
    console.log("movements X: " + movements.length);
    console.log("movements: " + JSON.stringify(movements));
    console.log("creiteria: " + JSON.stringify(criteria));
    const paginatedMovements = this.filterByCriteria(criteria, movements);
    console.log("paginatedMovements: " + JSON.stringify(paginatedMovements));
    return Promise.resolve(
      new Page<Movement>(
        paginatedMovements.length,
        paginatedMovements.slice(start, end)
      )
    );
  }

  async getMovementsFullWithReconciliationsByCompanyAndCriteria(companyUid: string, criteria: Criteria): Promise<Page<Movement>> {
    const movements = await this.getMovementsFullWithReconciliationsByCompanyUid(companyUid);
    const pageSize = criteria.pageSize;
    const start = (criteria.pageNumber - 1) * pageSize;
    const end = criteria.pageNumber * pageSize;
    console.log("movements X: " + movements.length);
    console.log("movements: " + JSON.stringify(movements));
    console.log("creiteria: " + JSON.stringify(criteria));
    const paginatedMovements = this.filterByCriteria(criteria, movements);
    console.log("paginatedMovements: " + JSON.stringify(paginatedMovements));
    return Promise.resolve(
      new Page<Movement>(
        paginatedMovements.length,
        paginatedMovements.slice(start, end)
      )
    );
  }



  async getMovementsByCompanyDistanceAndCriteria(companyUid: string, documentUid: string, type: string, criteria: Criteria): Promise<Page<Movement>> {
    const movements = await this.getMovementsByCompanyUidDistance(companyUid, documentUid, type);
    const pageSize = criteria.pageSize;
    const start = (criteria.pageNumber - 1) * pageSize;
    const end = criteria.pageNumber * pageSize;
    const paginatedMovements = this.filterByCriteria(criteria, movements);
    //console.log("start: " + start + " end: " + end);
    //console.log("getMovementsByCompanyDistanceAndCriteria paginatedMovements: " + JSON.stringify(paginatedMovements));

    return Promise.resolve(
      new Page<Movement>(
        paginatedMovements.length,
        paginatedMovements.slice(start, end)
      )
    );

  }


  async getMovementsFullByCompanyDistanceAndCriteria(companyUid: string, documentUid: string, type: string, criteria: Criteria): Promise<Page<Movement>> {
    const movements = await this.getMovementsFullByCompanyUidDistance(companyUid, documentUid, type);
    console.log("getMovementsFullByCompanyDistanceAndCriteria: FULL-->" + JSON.stringify(movements));
    const pageSize = criteria.pageSize;
    const start = (criteria.pageNumber - 1) * pageSize;
    const end = criteria.pageNumber * pageSize;
    const paginatedMovements = this.filterByCriteria(criteria, movements);
    //console.log("start: " + start + " end: " + end);
    //console.log("getMovementsFullByCompanyDistanceAndCriteria paginatedMovements: " + JSON.stringify(paginatedMovements));

    return Promise.resolve(
      new Page<Movement>(
        paginatedMovements.length,
        paginatedMovements.slice(start, end)
      )
    );

  }


  async getMovementsFullByCompanyClientDistanceAndCriteria(companyUid: string, documentUid: string, type: string,clientUid: string, criteria: Criteria): Promise<Page<Movement>> {
    const movements = await this.getMovementsFullByCompanyClientUidDistance(companyUid, documentUid, type, clientUid);
    console.log("getMovementsFullByCompanyClientDistanceAndCriteria: FULL-->" + JSON.stringify(movements));
    const pageSize = criteria.pageSize;
    const start = (criteria.pageNumber - 1) * pageSize;
    const end = criteria.pageNumber * pageSize;
    const paginatedMovements = this.filterByCriteria(criteria, movements);
    //console.log("start: " + start + " end: " + end);
    //console.log("getMovementsFullByCompanyDistanceAndCriteria paginatedMovements: " + JSON.stringify(paginatedMovements));

    return Promise.resolve(
      new Page<Movement>(
        paginatedMovements.length,
        paginatedMovements.slice(start, end)
      )
    );

  }


  async getMovementsFullByCompanyProviderDistanceAndCriteria(companyUid: string, documentUid: string, type: string,providerUid: string, criteria: Criteria): Promise<Page<Movement>> {
    const movements = await this.getMovementsFullByCompanyProviderUidDistance(companyUid, documentUid, type, providerUid);
    console.log("getMovementsFullByCompanyProviderDistanceAndCriteria: FULL-->" + JSON.stringify(movements));
    const pageSize = criteria.pageSize;
    const start = (criteria.pageNumber - 1) * pageSize;
    const end = criteria.pageNumber * pageSize;
    const paginatedMovements = this.filterByCriteria(criteria, movements);
    //console.log("start: " + start + " end: " + end);
    //console.log("getMovementsFullByCompanyDistanceAndCriteria paginatedMovements: " + JSON.stringify(paginatedMovements));

    return Promise.resolve(
      new Page<Movement>(
        paginatedMovements.length,
        paginatedMovements.slice(start, end)
      )
    );

  }


  async getMovementsFullByCompanyCollaboratorDistanceAndCriteria(companyUid: string, documentUid: string, type: string,collaboratorUid: string, criteria: Criteria): Promise<Page<Movement>> {
    const movements = await this.getMovementsFullByCompanyCollaboratorUidDistance(companyUid, documentUid, type, collaboratorUid);
    console.log("getMovementsFullByCompanyCollaboratorDistanceAndCriteria: FULL-->" + JSON.stringify(movements));
    const pageSize = criteria.pageSize;
    const start = (criteria.pageNumber - 1) * pageSize;
    const end = criteria.pageNumber * pageSize;
    const paginatedMovements = this.filterByCriteria(criteria, movements);
    //console.log("start: " + start + " end: " + end);
    //console.log("getMovementsFullByCompanyDistanceAndCriteria paginatedMovements: " + JSON.stringify(paginatedMovements));

    return Promise.resolve(
      new Page<Movement>(
        paginatedMovements.length,
        paginatedMovements.slice(start, end)
      )
    );

  }




  async getMovementsWithCompanyByCompanyAndCriteria(companyUid: string, criteria: Criteria): Promise<Page<MovementAccount>> {
    const movementsAccount = await this.getMovementsWithCompanyByCompanyUid(companyUid);
    //console.log("getMovementsWithCompanyByCompanyAndCriteria movements: " + JSON.stringify(movementsAccount));
    const pageSize = criteria.pageSize;
    const start = (criteria.pageNumber - 1) * pageSize;
    const end = criteria.pageNumber * pageSize;
    const paginatedMovements = this.filterMovementAccountByCriteria(criteria, movementsAccount);
    return Promise.resolve(
      new Page<MovementAccount>(
        paginatedMovements.length,
        paginatedMovements.slice(start, end)
      )
    );

  }




  async getMovementsByAccountAndCriteria(accountUid: string, criteria: Criteria): Promise<Page<Movement>> {
    const movements = await this.getMovementsByAccountUid(accountUid);
    console.log("getMovementsByAccountAndCriteria movements: " + JSON.stringify(movements));
    const pageSize = criteria.pageSize;
    const start = (criteria.pageNumber - 1) * pageSize;
    const end = criteria.pageNumber * pageSize;
    const paginatedMovements = this.filterByCriteria(criteria, movements);

    return Promise.resolve(
      new Page<Movement>(
        paginatedMovements.length,
        paginatedMovements.slice(start, end)
      )
    );

  }


  filterByCriteria(
    criteria: Criteria,
    _movements: Movement[]
  ): Movement[] {
    //TODO: implementar filtros
    let movements = Array<Movement>();
    if (criteria.filters.length > 0 && _movements.length > 0) {
      for (const filter of criteria.filters) {
        switch (filter.field) {
          case "movement_account_number": {
            if (_movements.length > 0) {
              movements = _movements.filter((movement) =>
                movement.movement_account_number
                  .toLowerCase()
                  .includes(filter.value.toLowerCase())
              );
            }
            break;
          }
          case "movement_description": {
            if (_movements.length > 0) {
              movements = _movements.filter((movement) =>
                movement.movement_description
                  .toLowerCase()
                  .includes(filter.value.toLowerCase())
              );
            }
            break;
          }
          case "movement_type": {
            if (_movements.length > 0) {
              movements = _movements.filter((movement) =>
                movement.movement_type
                  .toLowerCase()
                  .includes(filter.value.toLowerCase())
              );
            }
            break;
          }
          case "account_uid": {
            if (_movements.length > 0) {
              movements = _movements.filter((movement) =>
                movement.account_uid
                  .toLowerCase()
                  .includes(filter.value.toLowerCase())
              );
            }
            break;
          }
          case "movement_balance": {
            if (filter.operator === ">") {
              //console.log("filtrando por movement_balance (filterByCriteria):" + filter.operator);
              movements = _movements.filter((movement) =>
                movement.movement_balance !== undefined && movement.movement_balance > parseFloat(filter.value)
              );
            } else if (filter.operator === "<") {
              movements = _movements.filter((movement) =>
                movement.movement_balance !== undefined && movement.movement_balance < parseFloat(filter.value)
              );
            } else if (filter.operator === ">=") {
              movements = _movements.filter((movement) =>
                movement.movement_balance !== undefined && movement.movement_balance >= parseFloat(filter.value)
              );
            } else if (filter.operator === "<=") {
              movements = _movements.filter((movement) =>
                movement.movement_balance !== undefined && movement.movement_balance <= parseFloat(filter.value)
              );
            } else if (filter.operator === "=") {
              movements = _movements.filter((movement) =>
                movement.movement_balance !== undefined && movement.movement_balance === parseFloat(filter.value)
              );
            } else if (filter.operator === "!=") {
              movements = _movements.filter((movement) =>
                movement.movement_balance !== undefined && movement.movement_balance != parseFloat(filter.value)
              );
            }

            break;
          }

          case "company_uid": {
            if (_movements.length > 0) {
              movements = _movements.filter((movement) =>
                movement.company_uid
                  .toLowerCase()
                  .includes(filter.value.toLowerCase())
              );
            }
            break;
          }

          case "movement_total_amount": {
            console.log("(ApiMovementRepository)  case movement_total_amount:" + filter.operator);
            if (filter.operator === ">") {
             // console.log("filtrando por movement_amount:" + filter.operator);
              movements = _movements.filter((movement) =>
                movement.movement_total_amount !== undefined && movement.movement_total_amount > parseFloat(filter.value)
              );
            } else if (filter.operator === "<") {
              console.log("(ApiMovementRepository)  " + filter.operator);
              movements = _movements.filter((movement) =>
                movement.movement_total_amount !== undefined && movement.movement_total_amount < parseFloat(filter.value)
              );
              console.log("(ApiMovementRepository) < movements:" + JSON.stringify(movements));
            } else if (filter.operator === ">=") {
              movements = _movements.filter((movement) =>
                movement.movement_total_amount !== undefined && movement.movement_total_amount >= parseFloat(filter.value)
              );
            } else if (filter.operator === "<=") {
              movements = _movements.filter((movement) =>
                movement.movement_total_amount !== undefined && movement.movement_total_amount <= parseFloat(filter.value)
              );
              console.log("(ApiMovementRepository) <= movements:" + JSON.stringify(movements));
            } else if (filter.operator === "=") {
              movements = _movements.filter((movement) =>
                movement.movement_total_amount !== undefined && movement.movement_total_amount === parseFloat(filter.value)
              );
            } else if (filter.operator === "!=") {
              movements = _movements.filter((movement) =>
                movement.movement_total_amount !== undefined && movement.movement_total_amount != parseFloat(filter.value)
              );
            }

            break;
          }



        }
      }
    }
    return movements;
  }

  filterMovementAccountByCriteria(
    criteria: Criteria,
    _movements: MovementAccount[]
  ): MovementAccount[] {
    //TODO: implementar filtros
    let movements = Array<MovementAccount>();
    if (criteria.filters.length > 0) {
      for (const filter of criteria.filters) {
        switch (filter.field) {
          case "movement_account_number": {
            if (_movements.length > 0) {
              movements = _movements.filter((movement) =>
                movement.movement_account_number
                  .toLowerCase()
                  .includes(filter.value.toLowerCase())
              );
            }
            break;
          }
          case "movement_description": {
            if (_movements.length > 0) {
              movements = _movements.filter((movement) =>
                movement.movement_description
                  .toLowerCase()
                  .includes(filter.value.toLowerCase())
              );
            }
            break;
          }
          case "movement_type": {
            if (_movements.length > 0) {
              movements = _movements.filter((movement) =>
                movement.movement_type
                  .toLowerCase()
                  .includes(filter.value.toLowerCase())
              );
            }
            break;
          }
          case "account_uid": {
            if (_movements.length > 0) {
              movements = _movements.filter((movement) =>
                movement.account_uid
                  .toLowerCase()
                  .includes(filter.value.toLowerCase())
              );
            }
            break;
          }
          case "account_alias": {
            if (_movements.length > 0) {
              movements = _movements.filter((movement) =>
                movement.account_alias?.toLowerCase().includes(filter.value.toLowerCase())
              );
            }
            break;
          }
          case "movement_balance": {
            if (filter.operator === ">") {
              //console.log("filtrando por  movement_balance:" + filter.operator);
              movements = _movements.filter((movement) =>
                movement.movement_balance !== undefined && movement.movement_balance > parseFloat(filter.value)
              );
            } else if (filter.operator === "<") {
              movements = _movements.filter((movement) =>
                movement.movement_balance !== undefined && movement.movement_balance < parseFloat(filter.value)
              );
            } else if (filter.operator === ">=") {
              movements = _movements.filter((movement) =>
                movement.movement_balance !== undefined && movement.movement_balance >= parseFloat(filter.value)
              );
            } else if (filter.operator === "<=") {
              movements = _movements.filter((movement) =>
                movement.movement_balance !== undefined && movement.movement_balance <= parseFloat(filter.value)
              );
            } else if (filter.operator === "=") {
              movements = _movements.filter((movement) =>
                movement.movement_balance !== undefined && movement.movement_balance === parseFloat(filter.value)
              );
            }

            break;
          }

          case "company_uid": {
            //    console.log("filter company_uid:");
            const alfa = filter.value.toLowerCase();
            console.log("alfa:" + alfa);
            if (_movements.length > 0) {
              movements = _movements.filter((movement) =>
                movement.movement?.company_uid?.toLowerCase().includes(alfa)
              );
              //    console.log("----> movements:" + JSON.stringify(movements.filter((movement) => movement.movement?.company_uid?.toLowerCase().includes(alfa))));
            }
            break;
          }

          case "movement_amount": {
            if (filter.operator === ">") {
              //console.log("filtrando por movement_amount:" + filter.operator);
              movements = _movements.filter((movement) =>
                movement.movement_total_amount !== undefined && movement.movement_total_amount > parseFloat(filter.value)
              );
            } else if (filter.operator === "<") {
              movements = _movements.filter((movement) =>
                movement.movement_total_amount !== undefined && movement.movement_total_amount < parseFloat(filter.value)
              );
            } else if (filter.operator === ">=") {
              movements = _movements.filter((movement) =>
                movement.movement_total_amount !== undefined && movement.movement_total_amount >= parseFloat(filter.value)
              );
            } else if (filter.operator === "<=") {
              movements = _movements.filter((movement) =>
                movement.movement_total_amount !== undefined && movement.movement_total_amount <= parseFloat(filter.value)
              );
            } else if (filter.operator === "=") {
              movements = _movements.filter((movement) =>
                movement.movement_total_amount !== undefined && movement.movement_total_amount === parseFloat(filter.value)
              );
            } else if (filter.operator === "!=") {
              movements = _movements.filter((movement) =>
                movement.movement_total_amount !== undefined && movement.movement_total_amount != parseFloat(filter.value)
              );
            }

            break;
          }


        }
      }
    }
    return movements;
  }



}
